import type { DashboardUnresolvedCommentDocument } from "@models";
import { DashboardCommentThreadsDocumentList } from "./DashboardCommentThreadsDocumentList";

type DashboardUnresolvedCommentsListProps = {
  documents: DashboardUnresolvedCommentDocument[];
  selectedDeviceId?: string;
};

export const DashboardUnresolvedCommentsList = ({
  documents,
  selectedDeviceId,
}: DashboardUnresolvedCommentsListProps) => (
  <DashboardCommentThreadsDocumentList
    documents={documents}
    selectedDeviceId={selectedDeviceId}
    emptyText="No unresolved comments."
    threadStatusLabel="open"
    badgeColor="primary"
    getThreadIds={(document) => document.unresolvedThreadIds}
    rowTestIdPrefix="dashboard-unresolved-document-row"
    labelGroupTestIdPrefix="dashboard-unresolved-document-label-group"
    statusIconTestIdPrefix="dashboard-unresolved-document-status-icon"
    commentsButtonTestIdPrefix="dashboard-unresolved-document-comments-button"
    menuIdSuffix="unresolved"
  />
);
